"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSwipeable = require("react-swipeable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Carousel = function Carousel(_ref) {
  var container = _ref.container;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      carouselIndex = _useState2[0],
      setCarouselIndex = _useState2[1]; // handle container size change on resize


  (0, _react.useEffect)(function () {
    if (container.length > 0 && carouselIndex > container.length - 1) {
      setCarouselIndex(container.length - 1);
    }
  }, [carouselIndex, container.length]);

  var onPageChange = function onPageChange(change) {
    setCarouselIndex(function (prev) {
      var newValue = prev + change;
      var maxIndex = container.length - 1;

      if (newValue > maxIndex) {
        return 0;
      }

      if (newValue < 0) {
        return maxIndex;
      }

      return newValue;
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("table", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
    className: "w-5"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    className: "min-w-5 h-12 p-0 rounded",
    title: intl.formatMessage({
      id: 'common.previous'
    }),
    onClick: function onClick() {
      return onPageChange(-1);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.CarouselArrowLeft, {
    className: "w-3 h-10"
  }))), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement(_reactSwipeable.Swipeable, {
    onSwipedLeft: function onSwipedLeft() {
      return onPageChange(1);
    },
    onSwipedRight: function onSwipedRight() {
      return onPageChange(-1);
    },
    trackMouse: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-wrap justify-center items-center"
  }, container[carouselIndex])), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioGroup, {
    className: "justify-center flex-row mt-10",
    value: carouselIndex.toString(),
    onChange: function onChange(value) {
      return setCarouselIndex(Number(value));
    }
  }, container.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
      key: "widgetPage-".concat(container.indexOf(item)),
      className: "mr-3 last:mr-0",
      checkClassName: "h-2 w-2 m-0",
      value: container.indexOf(item).toString(),
      hideLabel: true
    });
  }))), /*#__PURE__*/_react["default"].createElement("td", {
    className: "w-5"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
    primary: true,
    className: "min-w-5 h-12 p-0 rounded",
    title: intl.formatMessage({
      id: 'common.next'
    }),
    onClick: function onClick() {
      return onPageChange(1);
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.CarouselArrowRight, {
    className: "w-3 h-10"
  })))))));
};

Carousel.propTypes = {
  container: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
Carousel.defaultProps = {
  container: []
};
var _default = Carousel;
exports["default"] = _default;